import { render } from "./BuyDossardBourseView.vue?vue&type=template&id=8c6b42d2"
import script from "./BuyDossardBourseView.vue?vue&type=script&lang=js"
export * from "./BuyDossardBourseView.vue?vue&type=script&lang=js"

import "./BuyDossardBourseView.vue?vue&type=style&index=0&id=8c6b42d2&lang=scss"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__